import { Glyph } from "../../../../types";

const SecondaryProfid: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 760 32" aria-hidden="true" {...props}>
      <rect x="0" y="0" width="760" height="32" fill="#333941" stroke="none" />
    </svg>
  );
};

export default SecondaryProfid;
